import React, { useEffect, useRef } from 'react';
import { Box, Button, Card, CardContent, Typography, Grid, Dialog, DialogContent, DialogContentText, DialogActions, FormControl, Select, MenuItem } from '@mui/material';
import InputField from "../../components/InputField"
import { FiSearch } from "react-icons/fi";
import DynamicTable from "../../components/common/table/DynamicTable";
import { useState } from "react";
import { message, Switch } from "antd";
import { RiDeleteBin5Line } from "react-icons/ri";
import DynamicFilter from "../../components/common/filter/DynamicFilter"
import axios from "axios";
import { API_URL } from "../../utils/constants";
import theme from '../../configs/theme';
import { useDispatch, useSelector } from "react-redux";
import { setUsersCounters, setUsersData } from '../../redux/features/appStateSlice';
import deletee from "../../assets/images/delete.png";
import allCards from "../../assets/images/icons/users/allUsers.png";
import activeUsers from "../../assets/images/icons/users/activeUsers.png";
import disabledAccounts from "../../assets/images/icons/users/disabledAccounts.png";
import { formattedDate } from '../../configs/formate';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';

// Add custom styles for SweetAlert
const customSwalStyles = `
  .swal2-custom-popup {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }
  .swal2-custom-popup .swal2-title {
    font-size: 1.5rem;
    font-weight: bold;
  }
  .swal2-custom-popup .swal2-html-container {
    margin: 1rem 0;
  }
  .swal2-custom-popup .swal2-confirm {
    font-weight: bold;
  }
  .swal2-custom-popup .swal2-cancel {
    font-weight: bold;
  }
`;

// Inject custom styles
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = customSwalStyles;
  document.head.appendChild(styleElement);
}

function Users() {

    const dispatch = useDispatch();
    const usersData = useSelector((state) => state.appState.users);
    const usersCounters = useSelector((state) => state.appState.usersCounters);
    const subscriptionTypes = useSelector((state) => state.appState.subTypes);
    const userData = useSelector((state) => state.appState.userData);
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState(usersData);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchWord, setSearchWord] = useState("");
    const currentPage = useRef(1);
    const currentLimit = useRef(5);
    const [userCount, setUserCount] = useState(0);
    const [counters, setCounters] = useState(usersCounters);
    const [updatingRowId, setUpdatingRowId] = useState(null);
    const [updatingSubscriptionId, setUpdatingSubscriptionId] = useState(null);
    const [deleteConfirmationDialogOpen, setDeleteConfirmationDialogOpen] = useState(false);
    const [deletedItemId, setDeletedItemId] = useState();
    const [filters, setFilters] = useState({
        subscriptionType: null,
        accStatus: null,
        dateOfRegistration: null,
        numberOfProfiles: null,
    });
    console.log(subscriptionTypes)
    const items = [
        { title: 'All Users', value: counters?.totalUsers, icon: <img src={allCards} alt="" style={{ width: "60px", height: "60px" }} /> },
        { title: 'Active Users', value: counters?.activeUsers, icon: <img src={activeUsers} alt="" style={{ width: "60px", height: "60px" }} /> },
        { title: 'Disabled Accounts', value: counters?.inactiveUsers, icon: <img src={disabledAccounts} alt="" style={{ width: "60px", height: "60px" }} /> },
        { title: 'Subscription Distribution', value: counters?.subscriptionUsers }
    ];

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
        currentPage.current = newPage;
        getUsers()
    };

    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, []);

    const handleRowsChange = (rows) => {
        currentPage.current = 1;
        currentLimit.current = rows;
        setPage(1);
        setRowsPerPage(rows);
        getUsers()
    };

    const handleClearFilter = () => {
        handleFilterChange(null)
    };

    const handleFilterChange = (data) => {

        if (data === null) {
            setFilters({
                subscriptionType: null,
                accStatus: null,
                dateOfRegistration: null,
                numberOfProfiles: null,
            });
        } else {


            setFilters((prevFilters) => ({
                ...prevFilters,
                subscriptionType: data?.subscriptionType || prevFilters.subscriptionType,
                accStatus: data?.profileStatus || prevFilters.accStatus,
                numberOfProfiles: data?.numberOfProfiles || prevFilters.numberOfProfiles,
                dateOfRegistration: data?.dateOfRegistration ? dayjs(data?.dateOfRegistration).format('YYYY-MM-DD') : prevFilters.dateOfRegistration
            }));
        }

    };


    const getUserCounters = async () => {
        setLoading(true);
        let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `${API_URL}/user/statics`,
            headers: {
                "Content-Type": "application/json",
            },
        };
        axios
            .request(config)
            .then((response) => {
                const parsedData = JSON.parse(response?.data);
                const counters = parsedData?.data;
                setCounters(counters)
                dispatch(setUsersCounters(counters));
                setLoading(false);
            })
            .catch((error) => {
                console.log("Error Get data: ", error);
                setLoading(false);
            });
    }




    const handleSubscriptionChange = async (userId, subscriptionId, newSubscriptionTypeId, currentSubscriptionTypeId) => {
        if (!newSubscriptionTypeId || newSubscriptionTypeId === currentSubscriptionTypeId) {
            return;
        }

        // Check if this is a downgrade by comparing subscription types
        const currentType = subscriptionTypes?.find(type => type.id === currentSubscriptionTypeId);
        const newType = subscriptionTypes?.find(type => type.id === newSubscriptionTypeId);
        
        if (!currentType || !newType) {
            message.error("Error in subscription type data");
            return;
        }

        // Check if current subscription is OneTime - prevent changes
        if (currentType.billing_frequency === 'OneTime') {
            message.error("OneTime subscriptions cannot be changed");
            return;
        }
        
        // Check if this is a downgrade (price comparison or billing frequency comparison)
        const isDowngrade = () => {
            // If both have prices, compare them
            if (currentType.price && newType.price) {
                return newType.price < currentType.price;
            }
            
            // If billing frequencies are different, consider it a downgrade if moving from longer to shorter period
            const frequencyOrder = {
                'OneTime': 1,
                'Monthly': 2,
                'Quarterly': 3,
                'Yearly': 4
            };
            
            if (currentType.billing_frequency && newType.billing_frequency) {
                return frequencyOrder[newType.billing_frequency] < frequencyOrder[currentType.billing_frequency];
            }
            
            // Default: if names are different, show confirmation
            return currentType.name !== newType.name;
        };
        
        const isUpgrade = () => {
            // If both have prices, compare them
            if (currentType.price && newType.price) {
                return newType.price > currentType.price;
            }
            
            // If billing frequencies are different, consider it an upgrade if moving to longer period
            const frequencyOrder = {
                'OneTime': 1,
                'Monthly': 2,
                'Quarterly': 3,
                'Yearly': 4
            };
            
            if (currentType.billing_frequency && newType.billing_frequency) {
                return frequencyOrder[newType.billing_frequency] > frequencyOrder[currentType.billing_frequency];
            }
            
            return false;
        };
        
        if (isDowngrade()) {
            // Determine the type of change for better messaging
            const getChangeType = () => {
                if (currentType.price && newType.price) {
                    const priceDiff = currentType.price - newType.price;
                    if (priceDiff > 50) return 'major_downgrade';
                    if (priceDiff > 20) return 'moderate_downgrade';
                    return 'minor_downgrade';
                }
                return 'general_change';
            };
            
            const changeType = getChangeType();
            const messages = {
                major_downgrade: {
                    title: 'Major Subscription Downgrade',
                    color: '#d33'
                },
                moderate_downgrade: {
                    title: 'Confirm Subscription Type Change',
                    color: '#f39c12'
                },
                minor_downgrade: {
                    title: 'Confirm Subscription Type Change',
                    color: '#3085d6'
                },
                general_change: {
                    title: 'Confirm Subscription Type Change',
                    color: '#3085d6'
                }
            };
            
            const currentMessage = messages[changeType];
            
            const result = await Swal.fire({
                title: currentMessage.title,
                html: `
                    <div style="text-align: left; direction: ltr;">
                        <p><strong>Are you sure you want to change the subscription type?</strong></p>
                         <p><strong>📅 Please note that Plan changes will be applied after current billing period ends</strong></p>
                        <div style="margin: 15px 0; padding: 10px; border-radius: 8px; background-color: #f8f9fa;">
                            <p style="margin: 5px 0;"><strong>From:</strong> <span style="color: ${currentMessage.color};">${currentType.name}</span></p>
                            <p style="margin: 5px 0;"><strong>To:</strong> <span style="color: #3085d6;">${newType.name}</span></p>
                            ${currentType.price && newType.price ? `
                                <p style="margin: 5px 0; font-size: 14px; color: #666;">
                                    Price: ${currentType.price}$ → ${newType.price}$
                                </p>
                            ` : ''}
                        </div>
                        <p style="color: ${currentMessage.color}; font-size: 14px; font-weight: bold;">
                             This change may affect user features
                        </p>
                    </div>
                `,
                icon: changeType === 'major_downgrade' ? 'error' : 'warning',
                showCancelButton: true,
                confirmButtonColor: currentMessage.color,
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Yes, Change Subscription Type',
                cancelButtonText: 'Cancel',
                reverseButtons: true,
                width: '450px',
                customClass: {
                    popup: 'swal2-custom-popup'
                }
            });

            if (!result.isConfirmed) {
                return;
            }
        } else if (isUpgrade()) {
            // Show a simple confirmation for upgrades
            const result = await Swal.fire({
                title: ' Subscription Type Upgrade',
                html: `
                    <div style="text-align: left; direction: ltr;">
                        <p><strong>Confirm Subscription Type Upgrade</strong></p>
                        <div style="margin: 15px 0; padding: 10px; border-radius: 8px; background-color: #e8f5e8;">
                            <p style="margin: 5px 0;"><strong>From:</strong> <span style="color: #666;">${currentType.name}</span></p>
                            <p style="margin: 5px 0;"><strong>To:</strong> <span style="color: #28a745;">${newType.name}</span></p>
                            ${currentType.price && newType.price ? `
                                <p style="margin: 5px 0; font-size: 14px; color: #666;">
                                    Price: ${currentType.price}$ → ${newType.price}$
                                </p>
                            ` : ''}
                        </div>
                        <p style="color: #28a745; font-size: 14px; font-weight: bold;">
                             This change will provide additional features to the user
                        </p>
                    </div>
                `,
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Yes, Upgrade Subscription Type',
                cancelButtonText: 'Cancel',
                reverseButtons: true,
                width: '450px',
                customClass: {
                    popup: 'swal2-custom-popup'
                }
            });

            if (!result.isConfirmed) {
                return;
            }
        }

        setUpdatingSubscriptionId(userId);
        
        // let config = {
        //     method: "put",
        //     maxBodyLength: Infinity,
        //     url: `${API_URL}/subscription/${subscriptionId}`,
        //     headers: {
        //         "Content-Type": "application/json",
        //     },
        //     data: {
        //         "performed_by": userData?.id,
        //         // "subscription_id": newSubscriptionTypeId
        //         "new_subscription_type_id": newSubscriptionTypeId

        //     }
        // };
             let config = {
            method: "put",
            maxBodyLength: Infinity,
            url: `${API_URL}/subscription/${subscriptionId}/change-plan`,
            headers: {
                "Content-Type": "application/json",
            },
            data: {
                // "performed_by": userData?.id,
                // // "subscription_id": newSubscriptionTypeId
                "new_subscription_type_id": newSubscriptionTypeId

            }
        };   
        axios
            .request(config)
            .then((response) => {
                getUsers();
                setUpdatingSubscriptionId(null);
                
                // Show different success messages based on the type of change
                if (isUpgrade()) {
                    message.success("Subscription type upgraded successfully, changes will be applied after current billing period ends.");
                } else if (isDowngrade()) {
                    message.success("Subscription type changed successfully, changes will be applied after current billing period ends.");
                } else {
                    message.success("Subscription type updated successfully, changes will be applied after current billing period ends.");
                }
            })
            .catch((error) => {
                console.log("Error updating subscription: ", error);
                message.error("Failed to update subscription type.");
                setUpdatingSubscriptionId(null);
            });
    };


    const columns = [
        {
            field: "full_name",
            headerName: "Name",
            flex: 1,
            sort: true,
            minWidth: "100px",
            editable: true,
            style: styles?.coulmn,
            align: "left",
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
            sort: true,
            minWidth: "100px",
            editable: true,
            style: styles?.coulmn,
            align: "left",
            headerClassName: "super-app-theme--header",
        },
        {
            field: "cards[0].count",
            headerName: "Profiles",
            minWidth: "50px",
            flex: 1,
            sort: true,
            style: styles?.coulmn,
            align: "left",
            headerClassName: "super-app-theme--header",
            renderCell: (params) => (
                <Box>
                    {params?.row?.cards[0]?.count <= 0 ? (
                        <span>_</span>
                    ) : (
                        <span>{params?.row?.cards[0]?.count}</span>
                    )}
                </Box>
            ),
        },
        {
            field: "subscription.subscription_type.name",
            headerName: "Subscription Type",
            minWidth: "180px",
            flex: 1,
            sort: true,
            style: styles?.coulmn,
            align: "left",
            headerClassName: "super-app-theme--header",
            renderCell: (params) => (
                <Box>
                    {(params.row.subscription) && (params.row.subscription.subscription_type) ? (
                        <FormControl 
                            size="small" 
                            sx={{ 
                                minWidth: 200,
                                width: 200,
                                '& .MuiOutlinedInput-root': {
                                    fontSize: '14px',
                                    height: '35px'
                                }
                            }}
                        >
                            <Select
                                value={params.row.subscription.subscription_type.id || ''}
                                onChange={(e) => handleSubscriptionChange(
                                    params.row.id, 
                                    params.row.subscription.id, 
                                    e.target.value,
                                    params.row.subscription.subscription_type.id
                                )}
                                disabled={updatingSubscriptionId === params.row.id || params.row.subscription.subscription_type.billing_frequency === 'OneTime'}
                                sx={{
                                    fontSize: '14px',
                                    '& .MuiSelect-select': {
                                        padding: '6px 12px'
                                    },
                                    '&.Mui-disabled': {
                                        backgroundColor: '#f5f5f5',
                                        opacity: 0.7
                                    }
                                }}
                                displayEmpty
                            >
                                {updatingSubscriptionId === params.row.id && (
                                    <MenuItem disabled>
                                        Updating...
                                    </MenuItem>
                                )}
                                {subscriptionTypes?.filter((t)=>t?.is_enabled==true).map((type) => (
                                    <MenuItem 
                                        key={type.id} 
                                        value={type.id}
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <span>{type.name}</span>
                                        {type.price && (
                                            <span style={{ 
                                                fontSize: '12px', 
                                                color: '#666',
                                                marginLeft: '8px'
                                            }}>
                                                ${type.price}
                                            </span>
                                        )}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    ) : (
                        <span>_</span>
                    )}
                </Box>
            ),
        },
        {
            field: "created_at",
            headerName: "Creation Date",
            flex: 1,
            style: styles?.coulmn,
            minWidth: "140px",
            sort: true,
            align: "left",
            headerClassName: "super-app-theme--header",
            renderCell: (params) => (
                <Box>
                    <span>{formattedDate(params.row.created_at)}</span>
                </Box>
            ),
        },
        {
            field: "renew_date",
            headerName: "Renew Date",
            flex: 1,
            style: styles?.coulmn,
            minWidth: "140px",
            sort: true,
            align: "left",
            headerClassName: "super-app-theme--header",
            renderCell: (params) => (
                <Box>
                    {(params.row.subscription) && (params.row.subscription.renew_date) ? (
                        <span>{formattedDate(params.row.subscription.renew_date)}</span>
                    ) : (
                        <span>_</span>
                    )}
                </Box>
            ),
        },

        {
            field: "is_enabled",
            sort: true,
            headerName: "Enable/Disable",
            headerClassName: "super-app-theme--header",
            minWidth: "50px",
            renderCell: (params) => (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Switch
                        style={{
                            backgroundColor: params?.row?.is_enabled ? theme.palette.primary.main : "",
                        }}
                        checked={params?.row?.is_enabled}
                        onChange={(value) => {
                            handleEnableDisableChange(params?.row?.id, value)
                        }}
                        loading={updatingRowId === params?.row?.id}
                        disabled={updatingRowId === params?.row?.id}
                    />
                </div>
            ),
        },
        {
            field: "action",
            headerName: "Action",
            align: "center",
            style: styles?.coulmn,
            headerClassName: "super-app-theme--header",
            renderCell: (params) => (
                <Box
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                     {/* <LuEye size="22.5px" style={{
                        color: "#16151C", cursor: "pointer",
                    }} />
                    <CiEdit size="22.5px" style={{
                        color: "#16151C", cursor: "pointer",
                    }} />  */}
                    <RiDeleteBin5Line size="22.5px" style={{
                        color: "#16151C", cursor: "pointer",
                    }}
                        onClick={() => {
                            setDeleteConfirmationDialogOpen(true)
                            setDeletedItemId(params?.row?.id)
                        }}
                    />
                </Box>
            ),
        },

    ];

    const filterData = {

        'Subscription Type': [
            {
                name: 'subscriptionType',
                gridWidth: { xs: 12, sm: 12 },
                list: subscriptionTypes?.map(type => ({
                    label: type.name,
                    value: type.id
                })),
                // list: [
                //     { label: 'Monthly Plan', value: 'monthly' },
                //     { label: 'Yearly Plan', value: 'yearly' },
                // ],
                type: 'radio', // Displays as a horizontal checkbox
                direction: 'horizontal',
                placeholder: 'Do you accept the terms and conditions?',
            },
        ],
        'Account Status': [
            {
                name: 'profileStatus',
                gridWidth: { xs: 12, sm: 12 },
                list: [
                    { label: 'Enabled', value: true },
                    { label: 'Disabled', value: false },
                ],
                type: 'radio', // Displays as a horizontal checkbox
                direction: 'horizontal',
                placeholder: 'Do you accept the terms and conditions?',
            },
        ],
        'Date of Registration': [
            {
                name: 'dateOfRegistration',
                gridWidth: { xs: 12, sm: 12 },
                type: 'date',
                placeholder: 'Select Date',
            },
        ],
        'Number of Profiles': [
            {
                name: 'numberOfProfiles',
                gridWidth: { xs: 12 },
                type: 'number',
                output: 'number',
                placeholder: 'Enter Number Of Profiles',
            },
        ],

    };


    const getParams = () => {

        const params = {
            page: currentPage.current,
            limit: currentLimit.current,
            search_full_name: searchWord,
            search_email: searchWord,
            "filter_cards.count": filters?.numberOfProfiles,
            filter_is_enabled: filters?.accStatus,
            "filter_subscription.subscription_type.id": filters?.subscriptionType,
            date_created_at: filters?.dateOfRegistration,
            sort_created_at: "desc"
        };
        return params;
    };
    const getUsers = async () => {
        setLoading(true);
        let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `${API_URL}/user`,
            headers: {
                "Content-Type": "application/json",
            },
            params: getParams(),
        };
        axios
            .request(config)
            .then((response) => {
                const parsedData = JSON.parse(response?.data);
                const users = parsedData?.data?.data;
                setUserCount(parsedData?.data?.count)
                dispatch(setUsersData(users));
                setUsers(users);
                setLoading(false);
                getUserCounters()

            })
            .catch((error) => {
                console.log("Error Get card: ", error);
                setLoading(false);
            });
    }
    useEffect(() => {
        getUsers()
    }, [rowsPerPage, searchWord, filters])

    const handleEnableDisableChange = async (id, value) => {
        setUpdatingRowId(id);
        let config = {
            method: "put",
            maxBodyLength: Infinity,
            url: `${API_URL}/user/${id}`,
            headers: {
                "Content-Type": "application/json",
            },
            data: { is_enabled: value }
        };
        axios
            .request(config)
            .then((response) => {
                getUsers()
                setUpdatingRowId(null);
            })
            .catch((error) => {
                console.log("Error update data: ", error);
            });
    }


    const deleteUser = async (id) => {
        setLoading(true);
        let config = {
            method: "DELETE",
            maxBodyLength: Infinity,
            url: `${API_URL}/user/${id}`,
            headers: {
                "Content-Type": "application/json",
            },
        };
        axios
            .request(config)
            .then((response) => {
                getUsers()
                setLoading(false);
                setDeleteConfirmationDialogOpen(false)
                message.success("The user was deleted successfully.");

            })
            .catch((error) => {
                setLoading(false);
                console.log("Error update data: ", error);
            });
    }

    const handleDeleteConfirmation = () => {
        deleteUser(deletedItemId);
    };

    return (
        <Box>
            {/* topside */}
            <Box>
                {/* titel and add btn */}
                <Box

                    xs={12}
                    sm={12}
                    md={9}
                    lg={9}
                    xl={9}
                    style={{
                        display: "flex",
                        gap: "14px",
                        marginTop: "-130px",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        marginLeft: "6px",
                    }}>
                    <Box style={{
                        display: "flex",
                        flexDirection: 'row',
                        gap: "14px",
                    }}>
                        <Typography
                            variant='h5'
                            style={{
                                color: theme.palette.basic.white,
                                fontWeight: "700",
                                lineHeight: "2.1rem",
                                marginLeft: "10px"
                            }}>
                            All Users
                        </Typography>
                    </Box>
                    {/* <AddButton
                    // onClick={() => {}}
                    >
                        +{" "}{"Add New User"}
                    </AddButton> */}

                </Box>
            </Box>
            {/* cards */}
            <Box
                spacing={2}
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: "8px",
                    gap: 2,
                    p: 1
                }}
            >
                {items?.map((item, index) => (
                    <Box key={index} xs={12} sm={6} md={3} lg={3} sx={{ width: { xs: '100%', sm: '48%', md: '23%' } }}>
                        <Card
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: item.icon ? "13.5px 20px" : "16.5px 20px",
                                boxShadow: `${theme.palette.shadow.blackOpacity} 0px 4px 4px`,
                                borderRadius: "8px",
                                gap: 2,
                            }}
                        >
                            <CardContent
                                sx={{
                                    width: item.icon ? '70%' : '100%',
                                    textAlign: 'left',
                                    p: 0
                                }}
                            >
                                <Typography variant='body2' sx={{ color: theme.palette.secondary.main, fontWeight: 800, lineHeight: "1.125rem" }} component="div">
                                    {item.title}
                                </Typography>
                                <Typography variant='h5' sx={{ color: theme.palette.primary.main, fontWeight: 800, lineHeight: "30.24px", mt: 1, ml: .5 }} component="div">
                                    {item.value}
                                </Typography>
                            </CardContent>

                            {item.icon ? (
                                <Box
                                // sx={{ ...styles.hoverEffectStyle }}
                                >
                                    {item.icon}
                                </Box>
                            ) : (
                                <Box>
                                </Box>
                            )}
                        </Card>
                    </Box>
                ))}
            </Box>
            {/* search and filter */}
            <Grid container
                spacing={1}
                style={{
                    paddingLeft: "10px",
                    marginTop: "10px",
                    marginLeft: "0",
                    backgroundColor: theme.palette.basic.white,
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px"

                }}>
                <Grid item xs={12} md={3} display={"flex"} alignItems={"center"}
                >
                    <Typography variant='h6'
                        style={{
                            color: theme.palette.secondary.main,
                            fontWeight: "700",
                        }}> All Users
                    </Typography>
                </Grid>
                <Grid item xs={12} md={9} display={"flex"} gap={"9px"} alignItems={"end"} justifyContent={"end"} style={{ padding: "15px 10px 15px 0" }}>

                    <Grid item xs={12} md={5}  >
                        <InputField
                            id="Search"
                            placeholder="Search by Name or Email."
                            type="text"
                            onChange={(e) => setSearchWord(e.target.value)}
                            startAdornment={<FiSearch size={24} color="#88939D" />}
                            variant="outlined"
                            sx={{
                                fontWeight: "500",
                                fontSize: "17px",
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={3} style={{ maxWidth: "fit-content" }}>
                        <DynamicFilter
                            width={'450px'}
                            onApply={(data) => handleFilterChange(data)}
                            filterData={filterData}
                            mainColor={theme.palette.primary.main}
                            inputsStyle={{ borderRadius: '10px', height: '45px', fontSize: '16px' }}
                            onClear={handleClearFilter}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <DynamicTable
                columns={columns}
                data={users}
                count={userCount}
                page={page}
                rowsPerPage={rowsPerPage}
                pageChange={handlePageChange}
                rowsChange={handleRowsChange}
                pagetype="users"
            />
            {/* delete */}
            <Dialog
                style={{ zIndex: 10, borderRadius: "30px" }}
                open={deleteConfirmationDialogOpen}
                onClose={() => setDeleteConfirmationDialogOpen(false)}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent style={{ padding: "30px" }}>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <img src={deletee} alt="" />
                    </div>
                    <DialogContentText sx={{ textAlign: "center" }}>
                        <Typography component="span" variant="h6" style={{ fontWeight: "bold", color: "black", textAlign: "center" }}>
                            Delete User
                        </Typography>
                    </DialogContentText>
                    <Typography component="span">
                        Are you sure you want to delete this User?
                    </Typography>
                </DialogContent>

                <DialogActions
                    style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        marginBottom: "20px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}
                >
                    <Button
                        variant="outlined"
                        style={{
                            color: "black",
                            borderColor: "lightgray",
                            width: "100%",
                        }}
                        onClick={() => setDeleteConfirmationDialogOpen(false)}
                        disabled={loading}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        style={{
                            background: "var(--Error, #FD4343)",
                            color: "white",
                            width: "100%",
                        }}
                        onClick={() => handleDeleteConfirmation()}
                        disabled={loading}
                    >
                        {loading ? "Deleting..." : "Yes, Delete"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>

    );
}


const styles = {
    coulmn: {
        color: "#172B4D",
        fontSize: "14.5px",
        fontWeight: "600",
        lineHeight: "20px",
    },
    hoverEffectStyle: {
        cursor: "pointer",
        borderRadius: 25,
        height: '60px',
        width: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'transform 0.3s, box-shadow 0.3s',
        '&:hover': {
            transform: 'scale(1.2)',
            boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.2)',
        }
    }
}
export default Users;
